import { Tooltip } from "@carbon6/c6-frontend-design";
import { formatCompactCount, formatNumber } from "@/utils/formats";

// K/M/B 로 축약한 카운트 셀. hover 는 전체값(천단위 구분)을 표시한다. 이 툴팁은 셀 텍스트와
// 다른 내용을 표시한다. 그래서 잘림 마커가 아니라 저작 툴팁이다(`CheckpointCount` 와 같은 판정).
// null 처리("—"/"-")는 호출부가 소유한다.
export function CompactCount({ value }: { value: number }) {
  return (
    <Tooltip content={formatNumber(value)}>
      <span>{formatCompactCount(value)}</span>
    </Tooltip>
  );
}
